interface Props {
  children?: React.ReactNode;
}

export const FormSectionContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className="lg:px-6 md:px-4 px-2.5 space-y-6 pb-4">{children}</div>
  );
};
